module.exports = __webpack_public_path__ + "static/media/image-card-7.5c1958b2.png";